
//#region INTERFACE IAutoOrderOrderingSettings
export interface IAutoOrderOrderingSettings {
  body: string;
  ccRecipients: string | string[];
  contactName: string;
  contactNumber: string;
  orderNumber: string;
  subject: string;
  pdfClause?: {
    text?: string;
  };
}

//#endregion